import { motion } from "framer-motion";
import { STEPS } from "@/lib/site";
import { Eyebrow, Reveal, EASE } from "./ui";

export const Processo = () => (
  <section id="processo" className="relative bg-[#111113] py-24 sm:py-36 overflow-hidden" data-testid="process-section">
    <div className="absolute inset-0 grain pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Procesi</Eyebrow>
            <h2 className="font-display font-light text-5xl sm:text-6xl text-[#F3EEE4] mt-6 leading-[1]">
              Katër hapa, <em className="text-gold-grad">një zanat</em>.
            </h2>
            <p className="mt-6 text-[#CFC8BA] leading-relaxed max-w-sm">Një bashkëbisedues i vetëm, nga zgjedhja e materialit deri te montimi përfundimtar.</p>
          </Reveal>
        </div>
      </div>
      <ol className="lg:col-span-8">
        {STEPS.map((s, i) => (
          <li key={s.n} className="relative py-10 sm:py-12" data-testid={`process-step-${s.n}`}>
            <motion.span
              className="absolute top-0 left-0 right-0 h-px bg-[#C9A55C]/50 origin-left"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 1.4, ease: EASE, delay: i * 0.05 }}
            />
            <Reveal className="grid sm:grid-cols-12 gap-4 sm:gap-8 items-baseline">
              <span className="sm:col-span-2 font-display italic text-6xl sm:text-7xl text-[#C9A55C] leading-none">{s.n}</span>
              <h3 className="sm:col-span-4 font-display text-3xl sm:text-4xl text-[#F3EEE4]">{s.title}</h3>
              <p className="sm:col-span-6 text-[#CFC8BA] leading-relaxed">{s.text}</p>
            </Reveal>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
